import Navbar from "react-bootstrap/Navbar";
import {Dropdown, Nav, NavDropdown} from "react-bootstrap";
import React, {useContext} from "react";
import {BackendContext} from "../context/Backend";
import {useLocation, useNavigate, useRouteLoaderData} from "react-router";
import styles from "./navigation.module.css";
import {Link, useSubmit} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Power} from "react-bootstrap-icons";

export const TopNav = (props) => {

    const backend = useContext(BackendContext);
    const {currentUser} = useRouteLoaderData("root");
    const navigate = useNavigate();
    const location = useLocation();
    const submit = useSubmit();
    const {t, i18n} = useTranslation();

    const logout = (e) => {
         backend.api.logout((resp)=>{
            submit(null, { method: "post", action: "/" });
            navigate("/login",{replace:true});
        },(error)=>{
             navigate("/error", backend.api.getErrorState(error));
        })
    }

    const handleLocale = (e) => {
        i18n.changeLanguage(e.currentTarget.getAttribute("data-locale"))
    }

    const brand = <Navbar.Brand>
        <img
            src="images/webso.png"
            width="200rem"
            alt="Webso logo"
            className={"navLogo"}
        />
    </Navbar.Brand>;

    const selectLanguage =
        <Dropdown className={"d-inline languageselect"}>
            <Dropdown.Toggle variant="outline-primary" size={"sm"} id="dropdown-basic" className={"mb-1"}>
                {t('system.language')}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item onClick={handleLocale} data-locale={"en"} active={i18n.language === 'en'}>{t('system.english')}</Dropdown.Item>
                <Dropdown.Item onClick={handleLocale} data-locale={"de"} active={i18n.language === 'de'}>{t('system.german')}</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>;

    const loggedInAs = currentUser ?
        <Dropdown className={"d-inline"}>
            <Navbar.Brand className={styles.label + " text-uppercase"}>{t('system.signedInAs')}</Navbar.Brand>
            <Dropdown.Toggle variant="primary" size={"sm"} id="dropdown-basic" className={"me-1 mb-1"}>
                {currentUser.generalInfo.login.value}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item onClick={logout}><Power className={"m-1 align-bottom"}/>{t('system.logout')}</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown> : "";

    return (<Navbar className={"border-bottom"}>
        {brand}
        {currentUser&&(
        <Nav activeKey={"/"}>
            {currentUser.roles?.find(r => r.name === 'Manager' && r.userManagement) && (
            <NavDropdown title={t('nav.userManagement')} active={location.hash === '#/' || location.hash === '' || location.hash === '#/credits'}>
                <NavDropdown.Item as={Link} to="/" active={location.hash === '#/' || location.hash === ''}>{t('nav.users')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/credits" active={location.hash === '#/credits'}>{t('nav.credits')}</NavDropdown.Item>
            </NavDropdown>)}
            {currentUser.roles?.find(r => r.name === 'Admin')&&(
            <Nav.Link as={Link} to="/delegations" active={location.hash === '#/delegations'}>{t('nav.delegations')}</Nav.Link>)}
            {currentUser.roles?.find(r => r.name === 'Manager'&&r.licenseManagement)&&(
            <NavDropdown title={t('nav.licensing')} active={location.hash === '#/licensed-users' || location.hash === '#/license'}>
                <NavDropdown.Item as={Link} to="/licensed-users" active={location.hash === '#/licensed-users'}>{t('nav.licensedUsers')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/license" active={location.hash === '#/license'}>{t('nav.licenseManagement')}</NavDropdown.Item>
            </NavDropdown>)}
            {/*<Nav.Link as={Link} to="/tyrclient">Tyr Client</Nav.Link>*/}
            {/*<Nav.Link as={Link} to="/tenantmanagement">Tenant Management</Nav.Link>*/}
        </Nav>)}
        <Navbar.Collapse className="justify-content-end">
            <Navbar.Text className={"loggedin"}>
                {loggedInAs}
                {selectLanguage}
            </Navbar.Text>
        </Navbar.Collapse>
    </Navbar>);
}